export default "__VITE_ASSET__d7223f90__"